import moment from 'moment';

export const TODAY_DATE = moment().format('YYYY-MM-DD');
export const TODAY_TIME = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
export const PREV_DATE = moment().subtract(1, 'day').format('YYYY-MM-DD');
export const PREV_DATE_START = moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
export const FIRST_DAY_OF_CURRENT_MONTH = moment().startOf('month').format('YYYY-MM-DD');
